import { z } from 'zod';

export type CredentialStatus = 'pending' | 'approved' | 'rejected';

export interface CredentialDocument {
  readonly id: string;
  readonly ownerId: string;
  readonly storagePath: string;
  readonly filename: string;
  readonly status: CredentialStatus;
  readonly ownerName: string | null;
  readonly createdAt: string;
}

const rowSchema = z.object({
  id: z.string(),
  owner_id: z.string(),
  storage_path: z.string(),
  filename: z.string(),
  status: z.enum(['pending', 'approved', 'rejected']),
  created_at: z.string(),
  owner: z.object({ full_name: z.string() }).nullable().optional(),
});

export function mapCredential(row: unknown): CredentialDocument {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    ownerId: r.owner_id,
    storagePath: r.storage_path,
    filename: r.filename,
    status: r.status,
    ownerName: r.owner?.full_name ?? null,
    createdAt: r.created_at,
  };
}

export const CREDENTIAL_MAX_BYTES = 5 * 1024 * 1024;
export const CREDENTIAL_TYPES = ['application/pdf', 'image/jpeg', 'image/png'] as const;
